var carModel = [
  {
    car: 'Acura',
    value: [
      {
        model: 'MDX',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-acura-mdx-2022-2025-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'RDX',
        value: [
          {year: "2019-2026",url: "https://3wliners.com/products/3w-floor-mats-compatible-for-acura-rdx-2019-2022-tpe-all-weather-custom-fit-floor-liner-for-acura-rdx-1st-and-2nd-row-full-set-car-liners-black"}
        ]
      }
    ]
  },
  {
    car: 'Audi',
    value: [
      {
        model: 'Q5/SQ5',
        value: [
          { year: "2018-2025",url: "https://3wliners.com/products/audi-q5-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2009-2017",url: "https://3wliners.com/products/3w-audi-q5-2009-2017-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Q7/SQ7',
        value: [
          { year: "2017-2026",url: "https://3wliners.com/products/audi-q7-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Q8/SQ8',
        value: [
          {year: "2019-2026",url: "https://3wliners.com/products/audi-q8-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'A6',
        value: [
          {year: "2026-2027",url: "https://3wliners.com/products/3w-2026-2027-audi-a6-floor-mats-thorex%E2%84%A2-all-weather-protection-not-fit-phev"}
        ]
      }
    ]
  },
  {
    car: 'BMW',
    value: [
      {
        model: '3 Series',
        value: [
          { year: "2019-2025",url: "https://3wliners.com/products/3w-bmw-3-series-2019-2023-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2013-2018",url: "https://3wliners.com/products/bmw-3-series-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: '5 Series',
        value: [
          { year: "2017-2023",url: "https://3wliners.com/products/3w-bmw-5-series-2017-2023-g30-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'iX',
        value: [
          {year: "2022-2026",url: "https://3wliners.com/products/3w-bmw-ix-2022-2024-custom-floor-mats-trunk-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'X3',
        value: [
          {year: "2025-2026",url: "https://3wliners.com/products/3w-bmw-x3-2025-2026-floor-mats-cargo-liner-set-thorex%E2%84%A2-all-weather-protection"},
          {year: "2018-2024",url: "https://3wliners.com/products/3w-bmw-2018-2023-x3-x4-floor-mats-cargo-mats-tpe-material-all-weather-protection"},
          { year: "2011-2017",url: "https://3wliners.com/products/bmw-x3-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'X4',
        value: [
          {year: "2019-2024",url: "https://3wliners.com/products/3w-bmw-2019-2023-x4-floor-mats-cargo-mats-tpe-material-all-weather-protection"},
          { year: "2015-2018",url: "https://3wliners.com/products/3w-bmw-x4-2015-2018-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'X5',
        value: [
          {year: "2019-2026",url: "https://3wliners.com/products/3w-bmw-x5-2019-2023-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"},
          { year: "2014-2018",url: "https://3wliners.com/products/bmw-x5-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'X6',
        value: [
          {year: "2020-2027",url: "https://3wliners.com/products/bmw-x6-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
    {
    car: 'Buick',
    value: [
      {
        model: 'Envista',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-custom-floor-mats-for-chevy-chevrolet-trax-2024-2025-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Enclave',
        value: [
          { year: "2025-2026",url: "https://3wliners.com/products/3w-buick-enclave-2025-2026-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
    ]
  },
  {
    car: 'Cadillac',
    value: [
      {
        model: 'Escalade 7-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-all-weather-custom-floor-mats-tpe-car-mars-trunk-mats-for-2021-2024-chevy-tahoe-gmc-yukon-cadillac-escalade-7-seat"}
        ]
      },
      {
        model: 'Escalade 8-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-chevy-tahoe-gmc-yukon-cadillac-escalade-only-for-8-seats-2021-2025-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Escalade ESV 7-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-chevy-suburban-gmc-yukon-xl-cadillac-escalade-esv-7-seat-2021-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'XT4',
        value: [
          {year: "2019-2025",url: "https://3wliners.com/products/3w-floor-mats-for-cadillac-xt4-2019-2022-custom-fit-tpe-all-weather-floor-liner-1st-and-2nd-row-car-mats-black"}
        ]
      },
      {
        model: 'XT5',
        value: [
          {year: "2016-2025",url: "https://3wliners.com/products/floor-mats-for-cadillac-xt5-2016-2022-custom-fit-car-front-rear-2-rows-liners-heavy-duty-waterproof-pad-car-mats-for-xt5-all-weather-black"}
        ]
      },
      {
        model: 'XTS',
        value: [
          { year: "2013-2019",url: "https://3wliners.com/products/3w-cadillac-xts-custom-floor-mats"}
        ]
      }
    ]
  },
  {
    car: 'Chevrolet',
    value: [
      {
        model: 'Blazer EV',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-honda-prologue-chevrolet-blazer-ev-cadillac-lyriq-2024-2026-floor-mats-trunk-mat-custom-mat-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Colorado',
        value: [
          { year: "2015-2022",url: "https://3wliners.com/products/chevrolet-colorado-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2023-2026",url: "https://3wliners.com/products/3w-custom-floor-mats-for-chevrolet-chevy-colorado-gmc-canyon-crew-cab-2023-2025-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Equinox',
        value: [
          {year: "2018-2024",url: "https://3wliners.com/products/chevrolet-equinox-custom-floor-mats-tpe-material-all-weather-protection"},
          {year: "2025-2027",url: "https://3wliners.com/products/3w-chevrolet-equinox-gas-vehicles-only-cargo-liner-seat-back-protector-2025-2026-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Equinox EV',
        value: [
          {year: "2024-2026",url: "https://3wliners.com/products/3w-chevrolet-equinox-ev-non-fuel-floor-mats-cargo-liner-2024-2025-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Silverado 1500',
        value: [
          {year: "2019-2026",url: "https://3wliners.com/products/chevrolet-silverado-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Silverado 2500/3500HD',
        value: [
          {year: "2020-2026",url: "https://3wliners.com/products/3w-custom-floor-mats-chevy-chevrolet-2500-hd-3500hd-2020-2026-crew-cab-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Silverado EV',
        value: [
          {year: "2024-2026",url: "https://3wliners.com/products/3w-chevrolet-silverado-ev-2024-2025fit-for-wt-rst-trim-gmc-sierra-ev-sierra-ev-denali-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Suburban 7-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-chevy-suburban-gmc-yukon-xl-cadillac-escalade-esv-7-seat-2021-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Trailblazer',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-thorex%E2%84%A2-floor-mats-for-chevrolet-trailblazer-awd-only-2021-2026-all-weather-protection"}
        ]
      },
      {
        model: 'Tahoe 7-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-all-weather-custom-floor-mats-tpe-car-mars-trunk-mats-for-2021-2024-chevy-tahoe-gmc-yukon-cadillac-escalade-7-seat"}
        ]
      },
      {
        model: 'Tahoe 8-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-chevy-tahoe-gmc-yukon-cadillac-escalade-only-for-8-seats-2021-2025-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Traverse',
        value: [
          { year: "2018-2023",url: "https://3wliners.com/products/chevrolet-traverse-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2024-2027",url: "https://3wliners.com/products/3w-chevrolet-traverse-gmc-acadia-acadia-denali-2024-2026-buick-enclave-2025-2026-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
 {
        model: 'Trax',
        value: [
          { year: "2024-2026 ",url: "https://3wliners.com/products/3w-custom-floor-mats-for-chevy-chevrolet-trax-2024-2025-thorex%E2%84%A2-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Dodge',
    value: [
      {
        model: 'Charger EV',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-dodge-charger-2026-cargo-liner-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Durango',
        value: [
          { year: "2016-2022",url: "https://3wliners.com/products/3w-floor-mats-dodge-durango-2016-2024-2nd-row-bench-seating-only-tpe-material-all-weather-protection"}
        ]
      },
    ]
  },
  {
    car: 'Ford',
    value: [
      {
        model: 'Bronco 2-Door',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-ford-bronco-2-door-2021-2023-floor-mats-trunk-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Bronco 4-Door',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/ford-bronco-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Bronco Sport',
        value: [
          {year: "2021-2026",url: "https://3wliners.com/products/3w-ford-bronco-sport-2021-2023-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Edge',
        value: [
          {year: "2015-2024",url: "https://3wliners.com/products/ford-edge-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Expedition 7-Seat',
        value: [
          {year: "2025-2027",url: "https://3wliners.com/products/3w-ford-expedition-7-seats-2025-2026-custom-floor-mats-crago-liner-thorex%E2%84%A2-all-weather-protection-only-standard"}
        ]
      },
      {
        model: 'Expedition Max 7-Seat',
        value: [
          {year: "2025-2027",url: "https://3wliners.com/products/3w-ford-expedition-max-7-seats-2025-custom-floor-mats-crago-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Expedition Max 8-Seat',
        value: [
          {year: "2025-2027",url: "https://3wliners.com/products/3w-ford-expedition-max-8-seats-2025-custom-floor-mats-crago-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Escape',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/ford-escape-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Explorer 6-Seat',
        value: [
          {year: "2020-2021",url: "https://3wliners.com/products/3w-ford-explorer-2020-2021-floor-mats-6-seat-includes-hybrid-thorex%E2%84%A2-all-weather-protection"},
          {year: "2022-2027",url: "https://3wliners.com/products/ford-explorer-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Explorer 7-Seat',
        value: [
          {year: "2020-2026",url: "https://3wliners.com/products/3w-ford-explorer-2020-2023-custom-7-seat-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'F150 with Underseat Storage',
        value: [
          { year: "2015-2026",url: "https://3wliners.com/products/3w-all-weather-floor-mats-fit-ford-f150-supercrew-cab-2015-2025-with-original-folding-under-seat-storage-box"}
        ]
      },
            {
        model: 'F150 without Underseat Storage',
        value: [
          { year: "2015-2026",url: "https://3wliners.com/products/3w-all-weather-floor-mats-fit-ford-f150-supercrew-cab-2015-2025-without-original-folding-under-seat-storage-box"}
        ]
      },
      {
        model: 'F250/F350/F450/F550',
        value: [
          {year: "2017-2026",url: "https://3wliners.com/products/3w-ford-f-250-f-350-f450-f550-2017-2024-super-duty-crew-cab-with-under-seat-storage-f250-f350-custom-floor-mats-bucket-seat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Maverick Hybrid',
        value: [
          {year: "2022-2026",url: "https://3wliners.com/products/3w-floor-mats-fit-for-ford-maverick-hybrid-2022-2023-2024-custom-floor-mats-tpe-material-all-weather-protect-only-for-hybrid"}
        ]
      },
      {
        model: 'Maverick Gasoline',
        value: [
          {year: "2022-2026",url: "https://3wliners.com/products/3w-ford-maverick-only-fits-gasoline-models-2022-2025-custom-floor-mats-thorex%E2%84%A2-all-weather-protect"}
        ]
      },
      {
        model: 'Mustang Mach-E',
        value: [
          {year: "2021-2026",url: "https://3wliners.com/products/ford-mustang-mach-e-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Ranger',
        value: [
          {year: "2020-2023",url: "https://3wliners.com/products/ford-ranger-custom-floor-mats-tpe-material-all-weather-protection"},
          {year: "2024-2027",url: "https://3wliners.com/products/3w-ford-ranger-2024-2026-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'GMC',
    value: [
      {
        model: 'Acadia/ Acadia Denali',
        value: [
          { year: "2024-2027",url: "https://3wliners.com/products/3w-gmc-acadia-acadia-denali-7-seat-2024-2026-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ] 
      },
      {
        model: 'Canyon',
        value: [
          { year: "2015-2022",url: "https://3wliners.com/products/chevrolet-colorado-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2023-2025",url: "https://3wliners.com/products/3w-custom-floor-mats-for-chevrolet-chevy-colorado-gmc-canyon-crew-cab-2023-2025-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Sierra 2500 HD/3500 HD',
        value: [
          {year: "2020-2026",url: "https://3wliners.com/products/gmc-sierra-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Sierra/Sierra Denali 1500',
        value: [
          {year: "2019-2026",url: "https://3wliners.com/products/3w-gmc-sierra-sierra-denali-1500-2019-2026-crew-cab-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Sierra EV/Sierra Denali EV',
        value: [
          {year: "2024-2026",url: "https://3wliners.com/products/3w-gmc-sierra-ev-sierra-ev-denali-crew-cab-2024-2026-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Terrain',
        value: [
          {year: "2018-2024",url: "https://3wliners.com/products/chevrolet-equinox-custom-floor-mats-tpe-material-all-weather-protection"},
          {year: "2025-2027",url: "https://3wliners.com/products/3w-gmc-terrain-terrain-denali-2025-2026-floor-mats-cargo-liner-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Yukon 7-Seat',
        value: [
          {year: "2021-2026",url: "https://3wliners.com/products/3w-all-weather-custom-floor-mats-tpe-car-mars-trunk-mats-for-2021-2024-chevy-tahoe-gmc-yukon-cadillac-escalade-7-seat"}
        ]
      },
      {
        model: 'Yukon 8-Seat',
        value: [
          {year: "2021-2026",url: "https://3wliners.com/products/3w-chevy-tahoe-gmc-yukon-cadillac-escalade-only-for-8-seats-2021-2025-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Yukon XL 7-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-chevy-suburban-gmc-yukon-xl-cadillac-escalade-esv-7-seat-2021-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Honda',
    value: [
      {
        model: 'Accord',
        value: [
          { year: "2023-2026",url: "https://3wliners.com/products/3w-honda-accord-2023-2024-hatchback-coupe-sedan-include-hybrid-model-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2018-2022",url: "https://3wliners.com/products/honda-accord-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Civic Gasoline',
        value: [
          {year: "2022-2027",url: "https://3wliners.com/products/3w-honda-civic-2022-2023-custom-floor-mats-cargo-liner-tpe-material-all-weather-protection"},
          {year: "2016-2021",url: "https://3wliners.com/products/honda-civic-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Civic Hybrid',
        value: [
          {year: "2022-2027",url: "https://3wliners.com/products/3w-2022-2027-honda-civic-hybrid-floor-trunk-mat-set-thorex%E2%84%A2-all-weather-protection"}
        ]
      },      
      {
        model: 'CR-V',
        value: [
          { year: "2023-2027",url: "https://3wliners.com/products/3w-honda-cr-v-2023-2024-non-hybrid-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"},
          { year: "2017-2022",url: "https://3wliners.com/products/honda-cr-v-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'HR-V',
        value: [
          { year: "2023-2027",url: "https://3wliners.com/products/3w-honda-hr-v-2023-2025include-hybrid-floor-mats-trunk-mat-custom-mat-tpe-material-all-weather-protection"}

        ]
      },
      {
        model: 'Odyssey',
        value: [
          {year: "2018-2026",url: "https://3wliners.com/products/honda-odyssey-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
            {
        model: 'Passport',
        value: [
          {year: "2026",url: "https://3wliners.com/products/3w-honda-passport-2026-floor-mats-cargo-liner-custom-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Pilot',
        value: [
          {year: "2023-2026",url: "https://3wliners.com/products/3w-honda-pilot-2023-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Prologue',
        value: [
          {year: "2024-2026",url: "https://3wliners.com/products/3w-honda-prologue-chevrolet-blazer-ev-cadillac-lyriq-2024-2026-floor-mats-trunk-mat-custom-mat-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Ridgeline',
        value: [
          {year: "2017-2026",url: "https://3wliners.com/products/3w-2017-2026-honda-ridgeline-floor-mats-thorex%E2%84%A2-custom-fit"}
        ]
      }     
    ]
  },
  {
    car: 'Hyundai',
    value: [
      {
        model: 'Elantra',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-hyundai-elantra-2021-2024-not-for-hybrid-or-elantra-n-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Elantra N',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-hyundai-elantra-n-2022-2026-only-fit-automatic-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
          ]
      },
      {
        model: 'Ioniq 5',
        value: [
          { year: "2022-2024",url: "https://3wliners.com/products/3w-hyundai-ioniq-5-2022-2023-only-for-sliding-console-custom-floor-mats-tpe-material-all-weather-protection"}

        ]
      },
      {
        model: 'Kona',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-hyundai-kona-2024-2025-gas-models-only-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}

        ]
      },
            {
        model: 'Palisade',
        value: [
          {year: "2026",url: "https://3wliners.com/products/3w-hyundai-palisade-7-seat-2026-only-for-bucket-seats-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Palisade 8-seat',
        value: [
          {year: "2020-2025",url: "https://3wliners.com/products/3w-hyundai-palisade-custom-7-8-seat-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
            {
        model: 'Palisade 7&8-seat',
        value: [
          {year: "2026",url: "https://3wliners.com/products/3w-hyundai-palisade-7-8-seats-2026-only-fit-hybrid-custom-floor-mats-cargo-liner-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Santa Fe 6&7-Seat Hybrid',
        value: [
          {year: "2024-2026",url: "https://3wliners.com/products/3w-hyundai-santa-fe-6-7-seat-2024-2026-only-for-hybrid-custom-floor-mats-trunk-mat-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Santa Fe 6-seat Gasoline',
        value: [
          {year: "2024-2026",url: "https://3wliners.com/products/3w-hyundai-santa-fe-6-seat-2024-2025-not-for-hybrid-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Santa Fe 7-seat Gasoline',
        value: [
          {year: "2024-2026",url: "https://3wliners.com/products/3w-hyundai-santa-fe-7-seat-2024-2025-only-gasoline-vehicle-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Santa Fe Gasoline',
        value: [
          {year: "2021-2023",url: "https://3wliners.com/products/3w-hyundai-santa-fe-5-seat-2020-2023-not-for-hybrid-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Santa Fe Hybrid',
        value: [
          {year: "2021-2023",url: "https://3wliners.com/products/3w-hyundai-santa-fe-2021-2023-only-for-hybrid-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Santa Cruz',
        value: [
          {year: "2022-2026",url: "https://3wliners.com/products/3w-hyundai-santa-cruz-2022-2025-2026-custom-pickup-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Sonata FWD',
        value: [
          {year: "2020-2026",url: "https://3wliners.com/products/3w-floor-mats-compatible-for-hyundai-sonata-2020-2022-kia-k5-2021-2022only-fwd-models-tpe-all-weather-custom-fit-floor-liner-for-hyundai-sonata-1st-2nd-row-full-set-car-liners-black"}
        ]
      },
      {
        model: 'Tucson',
        value: [
          {year: "2022-2026",url: "https://3wliners.com/products/3w-hyundai-tucson-2022-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Infiniti',
    value: [
      {
        model: 'QX65',
        value: [
          { year: "2027",url: "https://3wliners.com/products/3w-infiniti-qx65-2026-2027-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'QX60 7-Seat',
        value: [
          { year: "2022-2027",url: "https://3wliners.com/products/3w-floor-mats-for-nissan-pathfinder-8-seat-2022-2025-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'QX80',
        value: [
          { year: "2014-2018",url: "https://3wliners.com/products/3w-infiniti-qx80-2014-2018-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'QX56',
        value: [
          { year: "2011-2013",url: "https://3wliners.com/products/3w-infiniti-qx56-2011-2013-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Jaguar',
    value: [
      {
        model: 'F-pace',
        value: [
          { year: "2017-2026",url: "https://3wliners.com/products/jaguar-f-pace-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Jeep',
    value: [
      {
        model: 'Grand Cherokee L 6-Seat',
        value: [
          { year: "2021-2027",url: "https://3wliners.com/products/jeep-grand-cherokee-l-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Grand Cherokee L 7-Seat',
        value: [
          { year: "2021-2027",url: "https://3wliners.com/products/3w-jeep-grand-cherokee-l-7-seat-2021-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Cherokee',
        value: [
          { year: "2026-2027",url: "https://3wliners.com/products/3w-jeep-cherokee-2026-2027-custom-floor-mats-trunk-mat-seat-back-protector-thorex%E2%84%A2-all-weather-protection"},
          { year: "2015-2023",url: "https://3wliners.com/products/jeep-cherokee-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Compass',
        value: [
          { year: "2017-2026",url: "https://3wliners.com/products/3w-jeep-compass-2017-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Gladiator',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/3w-floor-mats-compatible-for-jeep-gladiator-2020-2022-tpe-all-weather-custom-fit-floor-liner-for-jeep-gladiator-1st-2nd-row-full-set-car-liners-with-grey-logo-black"}
        ]
      },
      {
        model: 'Grand Cherokee',
        value: [
          { year: "2022-2027",url: "https://3wliners.com/products/tpe-material-all-weather-custom-floor-mats-for-jeep-grand-cherokee"},
          { year: "Feb 2015-2021",url: "https://3wliners.com/products/3w-jeep-grand-cherokee-2016-2021-non-l-or-wk-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"},
          { year: "2013-Feb 2015",url: "https://3wliners.com/products/3w-jeep-grand-cherokee-2013-2015-non-l-or-wk-custom-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Grand Cherokee WK',
        value: [
          { year: "2022",url: "https://3wliners.com/products/3w-custom-floor-mats-jeep-grand-cherokee-wk-2022-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Grand Wagoneer 7-Seat',
        value: [
          { year: "2022-2025",url: "https://3wliners.com/products/3w-jeep-grand-wagoneer-2022-2024-7seat-custom-floor-mat-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Grand Wagoneer 8-Seat',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-jeep-grand-wagoneer-2022-2024-custom-8-seat-floor-mat-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Grand Wagoneer L',
        value: [
          { year: "2022-2025",url: "https://3wliners.com/products/3w-jeep-grand-wagoneer-l-2022-2024-custom-7-seat-floor-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Renegade',
        value: [
          { year: "2015-2024",url: "https://3wliners.com/products/3w-floor-mats-compatible-for-jeep-renegade-2015-2022-tpe-all-weather-custom-fit-floor-liner-for-jeep-renegade-1st-2nd-row-full-set-car-liners-black"}
        ]
      },
      {
        model: 'Wrangler 4XE Unlimited 4-Door',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/jeep-wrangler-4xe-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Wrangler JKU 4-Door',
        value: [
          { year: "2014-2018",url: "https://3wliners.com/products/3w-jeep-wrangler-jk-2013-2018-unlimited-4-door-only-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Wrangler JLU 4-Door',
        value: [
          { year: "2018-2026",url: "https://3wliners.com/products/jeep-wrangler-jl-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Wagoneer 7-Seat',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-jeep-wagoneer-2022-2026-7-seat-custom-floor-mat-trunk-mat-not-for-8-seat-l-s-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Wagoneer S EV',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-jeep-wagoneer-s-ev-2024-2026-custom-floor-mats-trunk-mat-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Kia',
    value: [
      {
        model: 'Carnival Hybrid 8-Seat',
        value: [
          { year: "2025-2027",url: "https://3wliners.com/products/3w-kia-carnival-hybrid-2025-2026-only-fit-8-seats-custom-floor-mats-cargo-liner-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Carnival Gasoline 8-Seat',
        value: [
          { year: "2022-2027",url: "https://3wliners.com/products/3w-kia-carnival-2022-2026-only-fit-gasoline-model-8-seat-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'K5 FWD',
        value: [
          { year: "2021-2027",url: "https://3wliners.com/products/kia-k5-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Sorento Gasoline',
        value: [
          { year: "2021-2027",url: "https://3wliners.com/products/3w-kia-sorento-6-7-seats-2021-2025-not-fit-for-hybrid-phev-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Sorento Hybrid',
        value: [
          { year: "2021-2027",url: "https://3wliners.com/products/3w-kia-sorento-2021-2025-only-fit-hybrid-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Sportage',
        value: [
          { year: "2023-2026",url: "https://3wliners.com/products/3w-kia-sportage-2023-2025-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Telluride',
        value: [
          { year: "2020-2025",url: "https://3wliners.com/products/3w-kia-telluride-2020-2025-gas-models-fits-7-8-seat-custom-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Telluride Hybrid',
        value: [
          { year: "2027",url: "https://3wliners.com/products/3w-2027-kia-telluride-hybrid-7-8-seats-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      }     
    ]
  },
  {
    car: 'Land Rover',
    value: [
      {
        model: 'Defender 110',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/range-rover-defender-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'LEXUS',
    value: [
      {
        model: 'ES',
        value: [
          { year: "2019-2024",url: "https://3wliners.com/products/3w-lexus-es-2019-2023-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'GX460 5-Seat',
        value: [
          { year: "2014-2023",url: "https://3wliners.com/products/3w-lexus-gx460-2014-2022-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'GX460 7-Seat',
        value: [
          { year: "2010-2023",url: "https://3wliners.com/products/3w-lexus-gx460-2010-2023-only-for-7-seats-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'GX550 5-Seat',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/toyota-land-cruiser-2024-2025-custom-floor-mats-cargo-liner"}
        ]
      }, 
      {
        model: 'NX',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-lexus-nx-2022-2023-not-for-hybrid-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2015-2021",url: "https://3wliners.com/products/lexus-nx-200t-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
         {
        model: 'RX',
        value: [
          { year: "2023-2026",url: "https://3wliners.com/products/lexus-rx-2023-2024-2025-rx350-rx350h-rx500h-floor-mats-all-weather-protection"},
          { year: "2016-2022",url: "https://3wliners.com/products/3w-floor-mats-set-for-lexus-rx-2016-2022-all-weather-custom-fit-car-floor-mats-with-odorless-tpe-heavy-duty-carpet-liner-for-lexus-rx350-rx450h-black"}
        ]
      },
        {
        model: 'RXL',
        value: [
          { year: "2018-2022",url: "https://3wliners.com/products/3w-lexus-rxl-rx350l-450hl-2018-2022-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      }     
    ]
  },
  {
    car: 'Lincoln',
    value: [
      {
        model: 'MKC',
        value: [
          { year: "2015-2019",url: "https://3wliners.com/products/lincoln-mkc-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'MKX',
        value: [
          { year: "2016-2018",url: "https://3wliners.com/products/lincoln-mkx-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Nautilus',
        value: [
          { year: "2019-2022",url: "https://3wliners.com/products/3w-lincoln-nautilus-2019-2022-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Mazda',
    value: [
      {
        model: 'CX-30 Gasoline',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/3w-mazda-cx-30-2020-2026-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'CX-5',
        value: [
          { year: "2017-2025",url: "https://3wliners.com/products/mazda-cx5-2017-2023-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2026-2027",url: "https://3wliners.com/products/3w-2026-2027-mazda-cx-5-2026-2027-floor-mats-cargo-mat-backrest-mats-thorex%E2%84%A2-all-weather-protection-gasoline-only"}, 
        ]
      },
      {
        model: 'CX-50',
        value: [
          { year: "2023-2026",url: "https://3wliners.com/products/3w-mazda-cx-50-2023-2025-gas-models-only-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'CX-50 Hybrid',
        value: [
          { year: "2025-2026",url: "https://3wliners.com/products/3w-mazda-cx-50-hybrid-2025-2026-custom-floor-mats-cargo-liner-seat-back-protector-lumedge%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'CX-70',
        value: [
          { year: "2025-2026",url: "https://3wliners.com/products/3w-mazda-cx-70-include-phev-2025-2026-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'CX-90 7-Seat',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-mazda-cx-90-fits-gas-phev-with-2nd-row-bucket-seats-2024-2026-custom-floor-mats-cargo-liner-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'CX-90 8-Seat',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-mazda-cx-90-8-seat-fits-gas-phev-with-2nd-row-bucket-seats-2024-2026-custom-floor-mats-cargo-liner-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Mercedes-Benz',
    value: [
      {
        model: 'C-CLass',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-mercedes-benz-c-class-2022-2024-for-sedan-only-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection?variant=43868960653365"},
          { year: "2015-2021",url: "https://3wliners.com/products/mercedes-benz-c-class-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'CLA',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/mercedes-benz-cla-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2014-2019",url: "https://3wliners.com/products/3w-mercedes-benz-cla-2014-2019-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'E-Class',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-floor-mats-fit-benz-e-class-2022-2024-e300-e320-e400-e350-e63-e550-custom-floor-liners-tpe-material-all-weather-protection"},
          { year: "2017-2023",url: "https://3wliners.com/products/mercedes-benz-e-class-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'G-Class',
        value: [
          { year: "2019-2025",url: "https://3wliners.com/products/mercedes-benz-g-class-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'GLA',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-mercedes-benz-gla-2021-2025-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2015-2020",url: "https://3wliners.com/products/mercedes-benz-gla-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'GLB',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/mercedes-benz-glb-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'GLC',
        value: [
          { year: "2023-2026",url: "https://3wliners.com/products/3w-mercedes-benz-glc-2023-2024-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"},
          { year: "2016-2022",url: "https://3wliners.com/products/mercedes-benz-glc-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'GLE',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/mercedes-benz-gle-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"},
          { year: "2016-2019",url: "https://3wliners.com/products/3w-mercedes-benz-gle-2016-2019-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'ML/GL/GLE/GLS',
        value: [
          { year: "2012-2019",url: "https://3wliners.com/products/mercedes-benz-gls-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Nissan',
    value: [
      {
        model: 'Altima',
        value: [
          { year: "2019-2026",url: "https://3wliners.com/products/nissan-altima-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Armada',
        value: [
          { year: "2017-2018",url: "https://3wliners.com/products/nissan-armada-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Frontier',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-floor-mats-truck-bed-mats-for-nissan-frontier-2022-2025-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Murano',
        value: [
          { year: "2025-2026",url: "https://3wliners.com/products/3w-nissan-murano-2025-custom-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Rogue',
        value: [
          { year: "2021-2027",url: "https://3wliners.com/products/nissan-rogue-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"},
          { year: "2014-2020",url: "https://3wliners.com/products/3w-nissan-rogue-2014-2020-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Pathfinder 7-Seat',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-floor-mats-for-nissan-pathfinder-7-seat-2022-2025-thorex%E2%84%A2-all-weather-protection"},
        ]
      },
      {
        model: 'Pathfinder 8-Seat',
        value: [
          { year: "2022-2027",url: "https://3wliners.com/products/3w-floor-mats-for-nissan-pathfinder-8-seat-2022-2025-thorex%E2%84%A2-all-weather-protection"},
        ]
      }
    ]
  },
  {
    car: 'Porsche',
    value: [
      {
        model: 'Cayenne',
        value: [
          { year: "2019-2026",url: "https://3wliners.com/products/porsche-cayenne-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Macan',
        value: [
          { year: "2014-2027",url: "https://3wliners.com/products/porsche-macan-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Ram',
    value: [
      {
        model: 'Ram 1500',
        value: [
          {year: "2025-2027",url: "https://3wliners.com/products/3w-dodge-ram-1500-2025-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"},
          {year: "2019-2024",url: "https://3wliners.com/collections/ram-1500-2019-2024"},
          {year: "2013-2018",url: "https://3wliners.com/products/3w-dodge-ram-1500-2013-2018-not-quad-cab-without-storage-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Ram 2500/3500',
        value: [
          {year: "2019-2027",url: "https://3wliners.com/products/3w-custom-floor-mats-for-2019-2025-dodge-ram-2500-3500-crew-cab-with-bucket-seats-not-for-pto-kit-models-thorex%E2%84%A2-all-weather-protection"},
          {year: "2013-2018",url: "https://3wliners.com/products/3w-dodge-ram-1500-2013-2018-not-quad-cab-without-storage-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Range Rover',
    value: [
      {
        model: 'Evoque',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/range-rover-evoque-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2011-2019",url: "https://3wliners.com/products/3w-range-rover-evoque-2011-2019-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Sport',
        value: [
          { year: "2023-2026",url: "https://3wliners.com/products/3w-range-rover-sport-2023-2024-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"},
          { year: "2014-2022",url: "https://3wliners.com/products/range-rover-sport-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Velar',
        value: [
          { year: "2017-2026",url: "https://3wliners.com/products/range-rover-velar-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
    {
    car: 'Rivian',
    value: [
      {
        model: 'R1S',
        value: [
          { year: "2022-2024",url: "https://3wliners.com/products/floor-liners-for-rivian-r1s-2022-2024?variant=51748808229227"}
        ]
      }
    ]
  },
  {
    car: 'Subaru',
    value: [
      {
        model: 'Crosstrek',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-floor-mats-cargo-liner-fit-for-2018-2023-subaru-crosstrek-2017-2023-subaru-impreza-custom-floor-mats-tpe-material-all-weather-protection-not-for-hybrid"}
        ]
      },
      {
        model: 'Forester',
        value: [
          { year: "2019-2024",url: "https://3wliners.com/products/subaru-forester-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2025-2026",url: "https://3wliners.com/products/3w-subaru-forester-2025-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Impreza',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-floor-mats-cargo-liner-fit-for-2018-2023-subaru-crosstrek-2017-2023-subaru-impreza-custom-floor-mats-tpe-material-all-weather-protection-not-for-hybrid"}
        ]
      },
      {
        model: 'Legacy',
        value: [
          { year: "2020-2025",url: "https://3wliners.com/products/3w-subaru-outback-legacy-2020-2025-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Outback',
        value: [
          { year: "2026-2027",url: "https://3wliners.com/products/3w-subaru-outback-2026-2027-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"},
          { year: "2020-2025",url: "https://3wliners.com/products/3w-subaru-outback-legacy-2020-2025-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      }      
    ]
  },
  {
    car: 'Tesla',
    value: [
      {
        model: 'Cybertruck',
        value: [
          { year: "2026",url: "https://3wliners.com/products/3w-tesla-cybertruck-2026-custom-floor-mats-trunk-mats-thorex%E2%84%A2-all-weather-protection"},
          { year: "2023-2025",url: "https://3wliners.com/products/3w-tesla-cybertruck-2023-2024-custom-floor-mats-trunk-mats-bed-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Model 3',
        value: [
          { year: "2024-2026 Highland New",url: "https://3wliners.com/products/3w-tesla-model-3-2024-custom-floor-mats-trunk-mats-tpe-material-all-weather-protection"},
          { year: "2021-2023",url: "https://3wliners.com/products/tesla-model-3-custom-floor-mats-trunk-mats-tpe-material-all-weather-protection?variant=42181163450421"}
        ]
      },
      {
        model: 'Model S',
        value: [
          { year: "2022-2025",url: "https://3wliners.com/products/3w-tesla-model-s-2022-2023-custom-floor-mats-trunk-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Model X',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-tesla-model-x-6-seat-2022-2023-custom-floor-mats-trunk-mats-tpe-material-all-weather-protection"}
        ]
      },
      {  
        model: 'Model Y',
        value: [
          { year: "2020-2024",url: "https://3wliners.com/products/tesla-model-y-custom-floor-mats-trunk-mats-tpe-material-all-weather-protection"}
        ]
      },
      {  
        model: 'Model Y Premium',
        value: [
          { year: "2025-2027",url: "https://3wliners.com/collections/tesla-model-y-juniper"}
        ]
      },
      {  
        model: 'Model Y Performance',
        value: [
          { year: "2025-2027",url: "https://3wliners.com/collections/tesla-model-y-juniper"}
        ]
      },
      {  
        model: 'Model Y Standard',
        value: [
          { year: "2025-2027",url: "https://3wliners.com/products/3w-tesla-model-y-standard-2025-2026-custom-floor-mats-trunk-mat-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Toyota',
    value: [
      {
        model: '4Runner Gasoline',
        value: [
          { year: "2013-2024",url: "https://3wliners.com/products/toyota-4runner-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2025-2026",url: "https://3wliners.com/products/3w-toyota-4runner-2025-2026-gas-models-5-seat-only-custom-floor-mats-cargo-liner-seat-back-protector-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: '4Runner Hybrid',
        value: [
          { year: "2025-2026",url: "https://3wliners.com/products/3w-toyota-4runner-2025-2026-hybrid-models-5-seat-only-custom-floor-mats-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'Camry',
        value: [
          { year: "2025-2026",url: "https://3wliners.com/products/3w-toyota-camry-2025-floor-mats-cargo-liner-include-hybrid-tpe-material-all-weather-protection"},
          { year: "2018-2024",url: "https://3wliners.com/products/toyota-camry-custom-floor-mats-tpe-material-all-weather-protection"} 
        ]
      },
      {
        model: 'Corolla Sedan',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/3w-toyota-corolla-sedan-not-for-cross-or-hatchback-2020-2024-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Grand Highlander',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-custom-floor-mats-fit-2024-toyota-grand-highlanderinclude-hybrid-lexus-tx-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Highlander',
        value: [
          { year: "2020-2026",url: "https://3wliners.com/products/3w-toyota-highlander-2020-2026-not-for-hybrid-custom-floor-mats-trunk-mat-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
            {
        model: 'Land Cruiser',
        value: [
          { year: "2024-2027",url: "https://3wliners.com/products/3w-toyota-land-cruiser-250-2024-2027-custom-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"}
        ]
      },
      {
        model: 'RAV4 Gasoline',
        value: [
          { year: "2019-2025",url: "https://3wliners.com/products/toyota-rav4-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2013-2018",url: "https://3wliners.com/products/3w-toyota-rav4-2013-2018-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
            {
        model: 'RAV4 Hybrid',
        value: [
          { year: "2026",url: "https://3wliners.com/products/3w-toyota-rav4-2026-fits-hv-model-without-trunk-subwoofer-only-floor-mats-trunk-mat-seat-back-protector-thorex%E2%84%A2-all-weather-protection"},
          { year: "2019-2025",url: "https://3wliners.com/products/3w-toyota-rav4-2019-2025-custom-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection-for-hybrid-only"}
        ]
      },
      {
        model: 'Sienna Platinum 7-Seat',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-toyota-2025-sienna-platinum-custom-floor-mats-trunk-mat"}
        ]
      },
      {
        model: 'Sienna 7-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/toyota-sienna-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Sienna 8-Seat',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-toyota-sienna-8-seat-2021-2023-custom-floor-mats-trunk-mat-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Sienna Trunk Mat Only',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/toyota-sienna-2021-2025-trunk-mat"}
        ]
      },
      {
        model: 'Tacoma Hybrid',
        value: [
          { year: "2024-2026",url: "https://3wliners.com/products/3w-custom-floor-mats-fit-hybrid-toyota-tacoma-2024-2025-thorex%E2%84%A2-all-weather-protection-double-cab"}
        ]
      },      
      {
        model: 'Tacoma Double Cab',
        value: [
          { year: "2024-2027",url: "https://3wliners.com/collections/all/products/3w-toyota-tacoma-2024-double-cab-automatic-transmission-floor-mats-tpe-all-weather-custom-fit"},
          { year: "2016-2023",url: "https://3wliners.com/products/3w-toyota-tacoma-2016-2023-only-for-crew-cab-floor-mats-tpe-all-weather-custom-fit"}
        ]
      },
      {
        model: 'Tundra',
        value: [
          { year: "2022-2026",url: "https://3wliners.com/products/3w-toyota-tundra-2022-2023-custom-floor-mats-tpe-material-all-weather-protection"},
          { year: "2014-2021",url: "https://3wliners.com/products/toyota-tundra-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Volkswagen',
    value: [
      {
        model: 'ID.4',
        value: [
          { year: "2021-2026",url: "https://3wliners.com/products/3w-volkswagen-id-4-2021-2023-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      },
      {
        model: 'Tiguan',
        value: [
          { year: "2025-2027",url: "https://3wliners.com/products/3w-volkswagen-tiguan-2025-2026-custom-floor-mats-cargo-liner-thorex%E2%84%A2-all-weather-protection"},
          { year: "2018-2024",url: "https://3wliners.com/products/volkswagen-tiguan-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  },
  {
    car: 'Volvo',
    value: [
      {
        model: 'XC60',
        value: [
          { year: "2018-2027",url: "https://3wliners.com/products/volvo-xc60-custom-floor-mats-tpe-material-all-weather-protection"}
        ]
      }
    ]
  }
]